import { fetchNewsPages } from '@/integrations/contentful';
import type { NewsPageType } from '@/views/NewsView/types';

export async function getNewsPages(
  language: string,
  countryCode: string,
  isPreview?: boolean | null,
): Promise<NewsPageType[]> {
  const pagesResponse = await fetchNewsPages(language, countryCode, isPreview);
  return (pagesResponse.pageCollection?.items || [])
    .filter((item): item is NonNullable<typeof item> => item !== null)
    .map((item) => ({
      ...item,
      thumbnail: item.thumbnail
        ? {
            ...item.thumbnail,
            sys: {
              ...item.thumbnail.sys,
              id: item.thumbnail.sys?.id || '',
            },
          }
        : null,
    })) as NewsPageType[];
}
